import { get } from "../../../logics/src/utils/helpers";
import { COUNTRIES_META } from 'constants/cart';
import { FORM_FIELD } from 'constants/address';
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from 'constants/vernacularConstants';
import { getStringFromId } from '../../../helpers/vernacular';
import { trackLatinCharactersDetected } from './tracking';
import { validateHouse, validateArea } from 'shared/wrapper/AddressWrapper/dependencies/helpers';
import { AppCallback, doCallAppCallback } from "helpers/utils/webView";
import { getPlatform } from "../../../helpers/index";
import { platformNames } from "constants/index";
import { ORIGIN_SOURCE } from "shared/constants/index";
import { validatePhoneNumber } from "helpers/utils/validatePhoneNumber";
import { validateName } from "helpers/utils/validateName";
import { validateEmail } from "helpers/utils/validateEmail";
import { validatePinCode } from "helpers/utils/validatePinCode";
import { isGrahakServiceEnabled } from "layouts/CheckoutPayment/helpers";



export const validateInputs = ({ addressForm, formError, fieldName, isEditing, isGuest }: {
  addressForm: AddressFormType,
  formError: FormErrorType,
  fieldName: string,
  isEditing: boolean,
  isGuest: boolean,
}) => {
  const { name, phone, email, house, area, pinCode, countryToShip } = addressForm;
  const currentErrors = Object.assign({}, formError);

  let fieldError = {
    error: '',
    hasError: false,
  };

  switch (fieldName) {
    case FORM_FIELD.PHONE:
      fieldError = validatePhoneNumber(phone);
    break;
    case FORM_FIELD.NAME:
      fieldError = validateName(name);
      if (fieldError.isLatinDetected) {
        trackLatinCharactersDetected({
          fieldName: FORM_FIELD.NAME,
        });
      }
      break;
    case FORM_FIELD.HOUSE:
      if (!isEditing) {
        fieldError = validateHouse(house);
        if (fieldError.isLatinDetected) {
          trackLatinCharactersDetected({
            fieldName: FORM_FIELD.HOUSE,
          });
        }
      }
      break;
    case FORM_FIELD.AREA:
      fieldError = validateArea(area);
      if (fieldError.isLatinDetected) {
        trackLatinCharactersDetected({
          fieldName: FORM_FIELD.AREA,
        });
      }
      break;
    case FORM_FIELD.EMAIL:
      if (email || isGuest) {
        fieldError = validateEmail(email);
      }
      break;
    case FORM_FIELD.PINCODE:
    if (countryToShip == COUNTRIES_META.IN.CODE) {
      fieldError = validatePinCode(pinCode);
    } else {
      if (!pinCode) {
        fieldError.error = getStringFromId(
           VERNACULAR_STRING_IDS.THIS_FIELD_IS_REQUIRED,
           VERNACULAR_DEFAULT_MESSAGES.THIS_FIELD_IS_REQUIRED,
          );
        fieldError.hasError = true;
      } else if (pinCode.length !== 5) {
        fieldError.error = getStringFromId(
          VERNACULAR_STRING_IDS.INVALID_PINCODE,
          VERNACULAR_DEFAULT_MESSAGES.INVALID_PINCODE,
         );
        fieldError.hasError = true;
      }  else if (parseInt(pinCode.charAt(0)) === 0) {
        fieldError.error = getStringFromId(
          VERNACULAR_STRING_IDS.INVALID_PINCODE_ZERO,
          VERNACULAR_DEFAULT_MESSAGES.INVALID_PINCODE_ZERO,
         );
        fieldError.hasError = true;
      } else {
        fieldError.error = '';
        fieldError.hasError = false;
      }
    }
    break;
    case 'all': {
      for (const key of Object.keys(FORM_FIELD)) {
        const field = FORM_FIELD[key];
        const errors = validateInputs({ addressForm, formError, fieldName: field, isEditing, isGuest });
        if (errors[field].hasError) {
          currentErrors[field] = errors[field];
          break; // Exits the loop as soon as an error is found
        }
      }
    }
    break;
    default:
      break;
  }

  currentErrors[fieldName] = fieldError;
  return currentErrors;
};

    /**
 *  getting country meta data from config flags reducer
 *
 */
export const getCountryMetaData = (configFlags: {result:{countryMetaData: any}}) => {
  const metaData = get(configFlags, 'result.countryMetaData');
  if (metaData) {
    return metaData;
  }
  return COUNTRIES_META;
};

/**
 *
 * @param previousForm previous address data that is edited
 * @param newForm new edited address form data.
 * @returns string that contains field names that are edited.
 */

export const getChangedFields = (previousForm: { firstName: string; phone: number; street: string; isSetDefault: boolean; postcode: number; }, newForm: { name: string; phone: string; area: string; house: string; isDefaultOptionChecked: boolean; pinCode: string; }) => {
  const {
    firstName,
    phone,
    street,
    isSetDefault,
    postcode,
  } = previousForm;
  const {
    name,
    phone: newPhone,
    area,
    house,
    isDefaultOptionChecked,
    pinCode,
  } = newForm;

  let changedFields = [];
  if (name && firstName && name != firstName) {
    changedFields.push(FORM_FIELD.NAME);
  }

  if (phone && newPhone && phone != newPhone) {
    changedFields.push(FORM_FIELD.PHONE);
  }

  if (street && area && street != area) {
    changedFields.push(FORM_FIELD.AREA);
  }

  if (house) {
    changedFields.push(FORM_FIELD.HOUSE);
  }

  if (pinCode && postcode && pinCode != postcode) {
    changedFields.push(FORM_FIELD.PINCODE);
  }

  if (isDefaultOptionChecked && isSetDefault && isDefaultOptionChecked != isSetDefault) {
    changedFields.push('useAddressDefaultToggle');
  }

  if (Array.isArray(changedFields) && changedFields.length > 0) {
    return changedFields.join(',');
  }
  return '';
};

export const handleBackRedirection = ({
  isGuest,
  shippingAddress,
  addressLength,
  isApp,
  sendTwoStepBack
}:any) => {
  /**
   * for guest user or user with zero saved address on back click redirect user to
   * cart page and if shipping addres is present send to checkout landing page
   */
  if (isGuest && !shippingAddress || (addressLength === 0 && !isGuest)) {
    /**
     * adding doRedirectTocallback for webview
     */
    if (isApp) {
      doCallAppCallback({
        name: AppCallback.DO_REDIRECT_TO_CART,
        data: {},
      });

      return;
    } 
  }

  /**
   * if addressback friction bottomsheet exp is enable 
   * then for save changes bottom sheet if user click on 
   * Don't save cta then send two step back.
   */
  if (sendTwoStepBack) {
    history.go(-2);
    return;
  }
  
  window.history.back();
};

/**
 * This will return params for edit and new address api for logged in and guest user.
 * Note : for beauty and man content-type is x-www-form-urlencoded and for fashion is application/json
 */
export const getAddressParams = ({ addressDetails, isGuest, deviceType }: any) => {
  let params = {} as IAddressParams | IAddressParamsGuest | IGrahakParams;
  let platform = getPlatform();
  /**
   * if user press enter in Road Name/Area/Colony then replace '/n' with space " " 
   * because at backend they replace '/n' with special character
   */
  const area = addressDetails.area?.replaceAll('\n', " "); // \n quote should be single quote don't change this

  if (isGuest) {
    params = {
      addressLine1: addressDetails.house,
      street: addressDetails.house + area,
      state: addressDetails.state,
      lastName: "",
      email: addressDetails.email,
      city: addressDetails.city,
      is_guest: 1,
      country: addressDetails.countryToShip,
      contactNumber: addressDetails.phone,
      firstName: addressDetails.name,
      addressLine2: area,
      postcode: addressDetails.pinCode,
      deviceType
    };
  } else {
    /**
     * for beauty and man
     */
    if (platform === platformNames.NYKAA || platform === platformNames.MEN) {
      const requestParams = new FormData();

      requestParams.append("originSource", ORIGIN_SOURCE.ADDRESS);
      requestParams.append("address_firstname", addressDetails.name);
      requestParams.append("address_lastname", "");
      requestParams.append("customer_email", addressDetails.email);
      requestParams.append("contact_number", addressDetails.phone);
      requestParams.append("city", addressDetails.city);
      requestParams.append("state", addressDetails.state);
      requestParams.append("country", addressDetails.countryToShip);
      requestParams.append("postcode", addressDetails.pinCode);
      requestParams.append("set_default", addressDetails.isAddressDefault ? "1" : "0");
      requestParams.append("isd_code", addressDetails.isdCode);
      requestParams.append("street", `${addressDetails.house} ${area}`);
      /**
       * appending customerAddressId for edit address 
       */
      if(addressDetails.customerAddressId){
        requestParams.append("address_id", addressDetails.customerAddressId);
        requestParams.append("customer_address_id", addressDetails.customerAddressId);
      }

      return requestParams;
    }
    /**
     * for fashion
     */
    params = {
      address: {
        addressLineOne: addressDetails.house,
        addressLineTwo: area,
        city: addressDetails.city,
        country: addressDetails.countryName,
        countryId: addressDetails.countryToShip,
        email: addressDetails.email,
        fullName: addressDetails.name,
        isDefault: addressDetails.isAddressDefault,
        mobileNumber: addressDetails.phone,
        pincode: addressDetails.pinCode,
        regionCode: addressDetails.regionCode,
        regionId: addressDetails.regionId,
        state: addressDetails.state,
      },
    };

    if(isGrahakServiceEnabled()){
      params = {
        addressLineOne: addressDetails.house,
        addressLineTwo: area,
        city: addressDetails.city,
        country: addressDetails.countryName,
        countryId: addressDetails.countryToShip,
        email: addressDetails.email,
        fullName: addressDetails.name,
        addressType: addressDetails.isAddressDefault ? 'default' : null,
        mobile: addressDetails.phone,
        pincode: addressDetails.pinCode,
        regionCode: addressDetails.regionCode,
        regionId: addressDetails.regionId,
        state: addressDetails.state,
      };
    }

    /**
     * appending customerAddressId for edit address 
     */
    if(addressDetails.customerAddressId){
      if(isGrahakServiceEnabled()){
        params.addressId = addressDetails.customerAddressId;
      }else{
        params.address.addressId = addressDetails.customerAddressId;
      }
    }
  }
  return params;
};